document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('.page-hero').forEach(hero => {
		const heroElement = hero.querySelector('.page-hero__title');
		if (!heroElement) return;
		const heroText = heroElement.textContent.split('');
		const letters = heroText.map(char => char !== ' ' ? `<span>${char}</span>` : char);
		const newLetters = letters.join('');
		heroElement.innerHTML = newLetters;
		heroElement.style.opacity = 1;
		const spans = heroElement.querySelectorAll('span');
		spans.forEach((span, index) => {
			setTimeout(() => {
				span.style.opacity = 1;
			}, index * 50);
		});
	});
});